const { InspectorControls } = wp.blockEditor;
const { PanelBody, SelectControl } = wp.components;
import ImageControl from '../wp-controlers/mediaUpload';
import SelectBackground from '../wp-controlers/select-background';
import SelectMaxWidth from '../wp-controlers/select-max-width';
import CommonPanel from '../wp-controlers/common-panel';

const Inspector = ({ attributes, setAttributes }) => {
  const { imageOption, contentPos, imgPosVertical } = attributes;

  return (
    <InspectorControls>
      <PanelBody title="Controles da Imagem" initialOpen={true}>
        <SelectControl
          label="Selecione a quantidade de imagens"
          title="Selecione a quantidade de imagens"
          value={imageOption}
          options={[
            { label: 'Uma', value: 'oneImage' },
            { label: 'Duas', value: 'twoImages' },
            { label: 'Imagem ocupando o banner todo', value: 'allImage' },
          ]}
          onChange={(position) => setAttributes({ imageOption: position })}
        />

        <div>
          <p>Primeira Imagem (Centro)</p>
          <ImageControl
            image="image"
            attributes={attributes}
            setAttributes={setAttributes}
          />
        </div>

        {imageOption === 'twoImages' && (
          <div>
            <p>Segunda Imagem</p>
            <ImageControl
              image="image2"
              attributes={attributes}
              setAttributes={setAttributes}
            />
          </div>
        )}

        {imageOption !== 'allImage' && (
          <SelectControl
            label="Posição vertical da imagem"
            title="Posição vertical da imagem"
            value={imgPosVertical}
            options={[
              { label: 'Topo', value: 'top' },
              { label: 'Centro', value: 'center' },
              { label: 'Baixo', value: 'bottom' },
            ]}
            onChange={(val) => setAttributes({ imgPosVertical: val })}
          />
        )}
      </PanelBody>

      <PanelBody title="Atributos do Hero" initialOpen={true}>
        <SelectBackground
          attributes={attributes}
          setAttributes={setAttributes}
        />

        <SelectControl
          label="Posição do Conteúdo"
          title="Posição do Conteúdo"
          value={contentPos}
          options={[
            { label: 'Esquerda', value: 'left' },
            { label: 'Direita', value: 'right' },
          ]}
          onChange={(position) => setAttributes({ contentPos: position })}
        />

        <SelectMaxWidth attributes={attributes} setAttributes={setAttributes} />
      </PanelBody>

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
};

export default Inspector;
